import React, { useState, useEffect, useRef } from 'react';
import { Close } from '@mui/icons-material';
import axios from 'axios';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import {
    Modal,
    Box,
    Button,
    Typography,
    Grid,
    Snackbar,
    Alert,
    TextField
} from '@mui/material';



// Nell’email, il cliente verrá avvisato dell’ accettazione della sua richiesta e che provvederemo noi al ritiro della merce. 
// Si richiederanno peso e dimensioni  del pacco, 
// la direzione completa di ritiro con la persona di contatto e il numero di telefono e si invieranno le nostre condizioni di RMA.  
// La direzione completa di ritiro con la persona di contatto e il numero di telefono vanno chieste ogni volta perche in alcuni casi sono differenti dai dati del cliente.
// Per velocizzare, potremmo mettere per il cliente un’opzione da marcare con “stesso indirizzo di registrazione” .
// In tutti e 3 i casi, si tratterá di email no-reply, e il cliente sará costretto ad entrare nel sul account per inserire le info mancanti. 



const RitiroClienteModal = ({ open, onClose }) => {
    const [formValues, setFormValues] = useState({
        pesoPacco: '',
        dimensionePacco: '',
        indirizzoRitiro: '',
        cap: '',
        citta: '',
        nazione: ''
    });
    const [isModified, setIsModified] = useState(false);
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const idCliente = user?.idCliente;
    const headers = {
        Authorization: `Bearer ${token}`
    };

    const { t } = useTranslation();
    const modalRef = useRef(null);


    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const handleInputChange = (field, value) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [field]: value
        }));
    };

    const handleSubmit = async() => {
        try {
            const payload = {
                ...formValues,
            };
            const responseDatiRitiro = await axios.post(`/cliente/salva/indirizzo/${idCliente}`, payload, { headers: headers});
            if (responseDatiRitiro.status === 200) {
                setAlert({ open: true, message: t('Dati inviati con successo!'), severity: 'success' });
                onClose();
            } else {
                setAlert({ open: true, message: t("Errore nell'invio dei dati!"), severity: 'error' });
            }
        } catch (error) {
            console.error("Errore nell'invio delle info del ritiro: ", error);
        }
    };


    const fields = [
        { name: 'pesoPacco',            label: t('Peso del pacco'),            type: 'text' },
        { name: 'dimensionePacco',      label: t('Dimensione del pacco'),      type: 'text' },
        { name: 'indirizzoRitiro',      label: t('Indirizzo di ritiro'),       type: 'text' },
        { name: 'cap',                  label: t('CAP'),                       type: 'text' },
        { name: 'citta',                label: t('Città'),                     type: 'text' },
        { name: 'nazione',              label: t('Nazione'),                   type: 'text' }
    ];


    return (
            <Box
                className="modal-container"
                sx={{
                    px: 4,
                    backgroundColor: 'white',
                    borderRadius: 2,
                    margin: 'auto',
                    overflowY: 'auto',
                }}
            >
                <Modal open={open} onClose={onClose}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Box sx={{
                        px: 4,
                        backgroundColor: 'white',
                        borderRadius: 2,
                        maxWidth: '85%',
                        maxHeight: '95%',
                        margin: 'auto',
                        overflowY: 'auto',
                        border: 'solid 2px #bdbdbd',
                        width: '90vw',
                    }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="h6" fontSize={25} my={3} sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                            {t('Inserisci i tuoi dati per il ritiro')}
                            </Typography>
                            <Button onClick={onClose}
                                sx={{
                                    position: 'relative',
                                    top: 0,
                                    right: 0,
                                    bgcolor: 'white'
                                }}>
                                <Close sx={{
                                    color: '#CCCCCC',
                                    '&:hover': {
                                        color: 'red',
                                    }
                                }} />
                            </Button>
                        </Box>
                        <Box>
                        <Grid container spacing={2}>
                    {fields.map((field) => (
                        <Grid item xs={12} sm={6} key={field.name}>
                            <TextField
                                label={field.label}
                                type={field.type}
                                value={formValues[field.name] || ''}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                                fullWidth
                                sx={{
                                    width: "100%",
                                    textAlign: "left",
                                    borderRadius: "10px",
                                    backgroundColor: "#FFFFFF",
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#fda03d"
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#fda03d"
                                        }
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "#fda03d"
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Box sx={{ textAlign: 'right' }}>
                                <Button variant="contained"
                                    sx={{
                                        borderRadius: '10px',
                                        width: '10em',
                                        backgroundColor: "#213d72",
                                        color: "#ffffff",
                                        mt: 2,
                                        mb: 2,
                                        "&:hover": {
                                            backgroundColor: "#1a315b",
                                            transform: "scale(1.05)",
                                        },
                                    }}
                                    autoFocus
                                    onClick={handleSubmit}>{t('Salva')}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>

                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                        {alert.message}
                    </Alert>
                </Snackbar>
            </Box>
    );
};

export default RitiroClienteModal;
